import React from 'react'

interface PremiumSwitchProps {
  isPremium: boolean
  renderPremiumUser: () => JSX.Element | null
  renderRegularUser: () => JSX.Element | null
}

const PremiumSwitch: React.SFC<PremiumSwitchProps> = ({
  isPremium, renderPremiumUser, renderRegularUser
}) => {
  if (isPremium) {
    return renderPremiumUser()
  }

  return renderRegularUser()
}

export default PremiumSwitch
